// tslint:disable
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { eventType } from '../../../common/text';
// tslint:enable

declare const GAMING: boolean;

@Component({
    selector: 'nda-complete-page',
    styleUrls: ['./nda-complete-page.component.scss'],
    templateUrl: './nda-complete-page.component.pug'
})
export class NdaCompletePage implements OnInit {
    private error: any;
    public event: string = eventType[GAMING ? 'gaming' : 'pfm'].toLowerCase();

    constructor(private titleService: Title) { }

    public ngOnInit() {
        // tslint:disable-next-line
        this.titleService.setTitle('NDA Completed');
    }

}
